import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { get } from 'ctm-util-functions';
import { DateInputSetWithInputs } from './date_input_set_inputs';

const DateInputSet = function (props) {
    useEffect(() => {
        const { dispatch, schema } = props;
        if (!get(props, 'rules.validation.result') && get(schema, 'resetOnUnMount', true)) {
            dispatch({
                type: 'SET_VALUE',
                identifier: schema.identifier,
                value: null,
                stateKey: schema.stateKey
            });
        }
    }, []);
    return <DateInputSetWithInputs {...props} />;
};

DateInputSet.propTypes = {
    dispatch: PropTypes.func.isRequired,
    schema: PropTypes.object.isRequired
};

export { DateInputSet };
